import { computed, inject, Service, signal } from '@angular/core';

import { UiStore } from './ui.store';

// rolul vine din token (claims.role): 0 = admin, 99 = Avizari CMR, 100 = CMJ.
// Avizari si admin au acces fara scoping pe CMJ in modulul IMI.
export const ROLURI_AVIZARI = [0, 99];

interface AuthState {
    isAuthenticated: boolean;
    isAdmin: boolean;
    accessToken: string;
    refreshToken: string;
}

const initialState: AuthState = {
    isAuthenticated: false,
    isAdmin: false,
    accessToken: '',
    refreshToken: '',
};

/** Autentificarea: sesiune, rol de administrator si tokenurile JWT. */
@Service()
export class AuthStore {
    private readonly ui = inject(UiStore);
    private readonly state = signal<AuthState>(initialState);

    readonly isAuthenticated = computed(() => this.state().isAuthenticated);
    readonly isAdmin = computed(() => this.state().isAdmin);
    /** Avizari (99) sau admin (0), dupa rolul din token. */
    readonly isAvizari = computed(() => ROLURI_AVIZARI.includes(this.ui.user()?.role ?? -1));
    readonly accessToken = computed(() => this.state().accessToken);
    readonly refreshToken = computed(() => this.state().refreshToken);

    setAuthenticated() {
        this.state.update(state => ({ ...state, isAuthenticated: true }));
    }

    setAdmin() {
        this.state.update(state => ({ ...state, isAdmin: true }));
    }

    setAccessToken(accessToken: string) {
        this.state.update(state => ({ ...state, accessToken }));
    }

    setRefreshToken(refreshToken: string) {
        this.state.update(state => ({ ...state, refreshToken }));
    }

    /** Iesire din sesiune: sterge rolul si tokenurile. */
    clear() {
        this.state.set(initialState);
    }
}
